module.exports = __webpack_public_path__ + "static/media/image-anak-2.ee676f36.png";